var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('label',[_vm._v("System Message")]),_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-ls-12 border p-3"},[_c('p',[_vm._v(_vm._s(_vm.message ? _vm.message : ""))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }